import React, {memo, useEffect, useMemo, useState} from "react";
import useStyles from "./useStyles";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ShowHideColumnsButton,
    MRT_TablePagination,
    MRT_ToggleDensePaddingButton,
    MRT_ToggleFiltersButton,
    MRT_ToggleGlobalFilterButton,
    useMaterialReactTable,
} from "material-react-table";
import {localization} from "../../Components/DirectoryBody/localizationVocabulary";
import Box from "@mui/material/Box";

/*
    @tableOptions - объект с настройками таблицы
    @tablesStylesOptions - объект со стилями, которые хотим переопределить !!!
*/
const StylizedMaterialReactTable = (props) => {
    const {tablesStylesOptions = {}, tableOptions = {}, className} = props;

    const classes = useStyles(tablesStylesOptions);

    // настройки пагинации пока храним глобально внутри компонента,
    // в будущем, возможно будем принимать их снаружи !!!
    const paginationInitialState = localStorage.getItem("tablePagination")
        ? JSON.parse(localStorage.getItem("tablePagination"))
        : {
            pageIndex: 0,
            pageSize: 10,
        };

    const [pagination, setPagination] = useState(paginationInitialState);

    useEffect(() => {
        localStorage.setItem("tablePagination", JSON.stringify(pagination));
    }, [pagination.pageIndex, pagination.pageSize]);

    const tableToolbar = (table, tableOptions) => {
        const renderCommonComponents = () => (
            <Box className={classes.toolbarMenu}>
                <MRT_TablePagination table={table}/>
                {!tableOptions?.onlyPagination && (
                    <>
                        <MRT_GlobalFilterTextField table={table} className={classes.showHideMenuItems}/>
                        <MRT_ToggleGlobalFilterButton table={table} className={classes.showHideMenuItems}/>
                        <MRT_ToggleFiltersButton table={table} className={classes.showHideMenuItems}/>
                        <MRT_ShowHideColumnsButton
                            table={table}
                            className={classes.showHideMenuItems}
                        />
                        <MRT_ToggleDensePaddingButton table={table} className={classes.showHideMenuItems}/>
                    </>
                )}
            </Box>
        );

        return renderCommonComponents();
    };

    const table = useMaterialReactTable({
        ...tableOptions,
        localization,
        paginationDisplayMode: "pages",
        onPaginationChange: setPagination,
        state: {pagination},
        renderColumnActionsMenuItems: ({internalColumnMenuItems}) => {
            return [
                internalColumnMenuItems.map((mi) => (
                    <div className={classes.menuItemProps}>{mi}</div>
                )),
            ];
        },
        renderTopToolbar: ({table}) => (
            tableToolbar(table, tableOptions)
        ),
    });

    return (
        <div
            className={`
                  ${classes.materialReactTableCustom}
                  ${className && className}
             `}>
            <MaterialReactTable table={table}/>
        </div>
    );
};

export default memo(StylizedMaterialReactTable);
